import { Box, Grid, Text, useColorModeValue } from '@chakra-ui/react'
import type { CurrentUserJson } from '../services/auth/auth.server'

interface Props {
    user: CurrentUserJson | null
    env: string
}

export default function Footer(props: Props) {
    const year = new Date().getFullYear()
    return (
        <Box as="footer" textAlign="center" fontSize="sm">
            <Box bg="#14335E" py={1}>
                <Text color="white" textAlign="center">
                    PHOCUS is supported by funding from the Australian Government Department of Health, Disability and
                    Ageing.
                </Text>
            </Box>
            <Box borderTop="1px solid" borderColor={useColorModeValue('gray.100', 'gray.700')} px={4} py={2}>
                <Grid templateColumns="1fr auto 1fr" alignItems="center">
                    <Text textAlign="left">
                        {props.user
                            ? `Logged in as: ${props.user.firstName} ${props.user.lastName} (${props.user.email})`
                            : 'Not Logged in'}
                    </Text>

                    <Text textAlign="center" fontWeight="medium">
                        Version 2.10.0
                    </Text>

                    <Box textAlign="right">
                        <Text>
                            &copy; {year} Commonwealth of Australia as represented by the Department of Health,
                            Disability and Ageing.
                        </Text>
                    </Box>
                </Grid>
            </Box>
        </Box>
    )
}
